// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__24mXf","title":"Info_title__3xuX-","links":"Info_links__1u0re","link":"Info_link__1b2Ja","logo":"Info_logo__3iZYE"};